async function initStockFirst() {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;

  // NEW ARRIVALS と ORIGINAL は対象外
  const path = window.location.pathname.replace(/\/$/, '');

  if (
    path === '/collections/new-arrivals' ||
    path === '/collections/doorman-store-1'
  ) {
    return;
  }

  if (grid.dataset.stockFirstDone === 'true') return;
  grid.dataset.stockFirstDone = 'true';

  const perPage = Number(grid.dataset.displayPerPage) || 24;

  const currentUrl = new URL(window.location.href);

  // Shopify標準ページネーションから総ページ数を取得
  const pagination = document.querySelector('.pagination-wrapper');
  let totalPages = 1;

  if (pagination) {
    const pageLinks = Array.from(
      pagination.querySelectorAll('a[href*="page="]')
    );

    pageLinks.forEach((link) => {
      const url = new URL(link.href);
      const page = Number(url.searchParams.get('page'));

      if (page > totalPages) {
        totalPages = page;
      }
    });
  }

  const allItems = [];

  // 1ページ目
  document
    .querySelectorAll('#product-grid > .grid__item')
    .forEach((item) => {
      allItems.push(item.cloneNode(true));
    });

  // 2ページ目以降を取得
  for (let page = 2; page <= totalPages; page++) {
    const url = new URL(currentUrl.href);
    url.searchParams.set('page', page);

    const response = await fetch(url.toString());
    if (!response.ok) continue;

    const html = await response.text();

    const doc = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    doc
      .querySelectorAll('#product-grid > .grid__item')
      .forEach((item) => {
        allItems.push(item.cloneNode(true));
      });
  }

  // 在庫あり → SOLD OUT の順
  const available = allItems.filter(
    (item) => item.dataset.available === 'true'
  );

  const soldOut = allItems.filter(
    (item) => item.dataset.available === 'false'
  );

  const sortedItems = [...available, ...soldOut];

  const params = new URLSearchParams(window.location.search);
  const currentPage = Math.max(
    1,
    Number(params.get('page')) || 1
  );

  const start = (currentPage - 1) * perPage;
  const end = start + perPage;

  grid.innerHTML = '';

  sortedItems
    .slice(start, end)
    .forEach((item) => {
      grid.appendChild(item);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initStockFirst
  );
} else {
  initStockFirst();
}